(ns app.front.ui.filter-common
  (:require [app.front.ui :as ui]
            [app.front.ui.filter-button :as ui-fb]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag]]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [>evt <sub]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [reagent.core :as r]))


(defn filter-values->conditions
  ([filter-values]
   (filter-values->conditions filter-values #{:form-fields}))
  ([filter-values vector-attributes]
   (->> filter-values
        (keep (fn [[k vs]]
                (when k
                  {:filter.condition/attribute k
                   :filter.condition/operator  :equals
                   :filter.condition/values    (if (contains? vector-attributes k)
                                                 (vec vs)
                                                 (set vs))}))))))


(defn save-filter-controls [tr {:keys [saving-filter?
                                       filters
                                       save-evt
                                       save-evt-opts
                                       save-tr-key
                                       loading-tr-key
                                       filter-name-tr-key]}]
  (r/with-let [*input-visible?  (r/atom false)
               *new-filter-name (r/atom "")
               *combo-box-value (r/atom "")]
    (let [reset-save   (fn []
                         (reset! *input-visible? false)
                         (reset! *new-filter-name "")
                         (reset! *combo-box-value ""))
          filter-names (map :filter/name filters)
          cb-items     (concat (when-not (or (str/blank? @*combo-box-value)
                                             (some #(= % @*combo-box-value) filter-names))
                                 [@*combo-box-value])
                               (map :filter/name filters))]
      (cond
        saving-filter?
        (cc/inline-loading {:description (tr [loading-tr-key])
                            :class-name  "self-center -mt-1"})

        @*input-visible?
        [:form.flex.flex-0.w-full.save-search-form
         {:on-submit (fn [e]
                       (.preventDefault e)
                       (>evt [save-evt @*new-filter-name save-evt-opts])
                       (reset-save))}
         [:div {:style {:min-width "18rem"}}
          (cc/combo-box {:id              "new-filter-name"
                         :class-name      "w-full"
                         :on-change       #(->> ^js % .-selectedItem (reset! *new-filter-name))
                         :on-input-change #(reset! *combo-box-value %)
                         :light           true
                         :placeholder     (tr [filter-name-tr-key])
                         :items           cb-items})]
         (cc/button {:kind             :ghost
                     :size             :small
                     :icon             i/remove
                     :icon-position    :right
                     :icon-description (tr [:cancel])
                     :class-name       "only-icon-button"
                     :on-click         reset-save}
                    "")
         (cc/button {:type             :submit
                     :kind             :ghost
                     :size             :small
                     :icon             i/check
                     :icon-position    :right
                     :icon-description (tr [:save])
                     :class-name       "only-icon-button"
                     :disabled         (str/blank? @*new-filter-name)}
                    "")]

        :else
        [:div.hidden.md:block
         (cc/button {:kind     :ghost
                     :size     :small
                     :on-click #(reset! *input-visible? true)}
                    (tr [save-tr-key]))]))))


(defn dashboard-user-filter-controls
  [{:keys [tr title save-tr-key user-filters selected-filter default-filters? config-loading?
           saving-filter? save-evt delete-evt select-filter-evt clear-search-evt]}]
  [:div.flex.flex-1.w-full.flex-wrap.justify-between
   [:div.flex.items-center.mt-2.h-8
    [:h3.mb-0.mr-3.-mt-1 (tr [title])]
    (when-not default-filters?
      [:<>
       (cc/button {:kind       :ghost
                   :size       :small
                   :on-click   #(>evt [clear-search-evt])
                   :aria-label (tr [:dashboard-search/clear-all-filters])}
                  (tr [:clear]))
       (when-not selected-filter
         [save-filter-controls tr (util/mmap {:filters            user-filters
                                              :save-tr-key        (or save-tr-key :dashboard-search/save-filter)
                                              :loading-tr-key     :dashboard-search/saving-filter
                                              :filter-name-tr-key :dashboard-search/filter-name}
                                             save-evt
                                             saving-filter?)])])]
   [:div.flex.flex-0.items-center.mt-2.h-8.w-full.md:w-auto
    [:div.hidden.md:block
     (when selected-filter
       [ui/modal-confirmation-button
        {:id                  "delete-filter-button"
         :tr                  tr
         :modal-title         (tr [:dashboard-search/delete-filter-title])
         :trigger-button-opts {:kind          :ghost
                               :size          :small
                               :icon-position :left
                               :class-name    (str "text-ui-red-100 hover:border-ui-red-100 hover:text-ui-white "
                                                   "hover:bg-ui-red-100 focus:text-ui-white focus:bg-ui-red-100 "
                                                   "focus:outline-none")}
         :trigger-button-text (tr [:dashboard-search/delete-filter])
         :on-yes-click        #(>evt [delete-evt (:db/id selected-filter)])}
        (tr [:dashboard-search/delete-filter-modal]
            [(:filter/name selected-filter)])])]
    [:div.w-full.md:w-64
     (if config-loading?
       (cc/select-skeleton {:hide-label true})
       [ui-select/select
        {:id           "saved-workspace-searches"
         :class-name   "full-width-select"
         :allow-empty? false
         :select-text  (tr [:dashboard-search/saved-filters-select])
         :values       user-filters
         :on-change    #(>evt [select-filter-evt %])
         :value        selected-filter
         :val->str     :filter/name}])]]])


(def search-filter-label-attributes
  {:permit-type :main-permit-type})


(defn filter-label [tr attribute]
  (tr [(if (and (= :group/id attribute)
                (ff/enabled? :feature-flag.id/workspace-search-updates))
         :search/department
         (keyword "search-filter-attribute"
                  (->> [(namespace attribute) (name (get search-filter-label-attributes attribute attribute))]
                       (remove nil?)
                       (str/join "-"))))]))


(defn date-range->str [tr attribute {:keys [from to]}]
  (let [label (filter-label tr attribute)
        from  (date-util/date from)
        to    (date-util/date to)]
    (cond
      (and from to) (tr [:search/date-range-between] [label from to])
      from          (tr [:search/date-range-since] [label from])
      :else         (tr [:search/date-range-until] [label to]))))


(def condition-width-classes " w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-2 mt-2")


(defn date-range-values?
  "The search config offers `:date-range` for attributes that are filtered by a date range
  instead of a set of options."
  [values]
  (= #{:date-range} (set values)))


;; The legend titles the range, as the placeholders disappear once dates are picked
(defn- date-range-filter [{:keys [tr id label-text value light? on-change]}]
  (let [{:keys [from to] :as date-range} (first value)
        date-picker                      (fn [k placeholder opts]
                                           [ui/date-picker (merge {:id          (str id "-" (name k))
                                                                   :tr          tr
                                                                   :label-text  placeholder
                                                                   :hide-label  true
                                                                   :placeholder placeholder
                                                                   :width       "100%"
                                                                   ;; The page font instead of Carbon's monospace one,
                                                                   ;; like the multi-selects next to it
                                                                   :class-input (str "![font-family:inherit]"
                                                                                     (when light? " !bg-ui-white"))
                                                                   :clearable?  true
                                                                   :value       (get date-range k)
                                                                   :callback    (partial on-change k)}
                                                                  opts)])]
    [:fieldset.border-0.p-0.m-0
     [:legend.text-sm.font-semibold.text-ui-night-sky-100.mb-1 label-text]
     [:div.flex.gap-2
      (date-picker :from (tr [:search/date-range-from]) {:class-name "flex-1"
                                                         :max-date   to})
      (date-picker :to (tr [:search/date-range-to]) {:class-name "flex-1"
                                                     :min-date   from})]]))


(defn dashboard-filter-selects
  [{:keys [tr config-loading? conditions filter-values revision val->str-fn set-filter-value-evt
           set-date-range-bound-evt light? mobile?]}]
  (let [width-class (if mobile? "w-full mt-4" (str "hidden md:block" condition-width-classes))]
    (if config-loading?
      (->> (repeat 4 [:div {:class width-class}
                      (cc/select-skeleton {:hide-label true})])
           (cons :<>)
           vec)
      (let [filterable-multi-select?         (<sub [::ff/enabled? :feature-flag.id/dashboard-filterable-multi-select])
            {date-ranges true selects false} (group-by (comp date-range-values? :values) conditions)
            ;; Revision redraws the filterable multi-select when its value changes externally, as it
            ;; only accepts an initial selection; the ordinary multi-select is controlled.
            id                               (fn [attr]
                                               (str (when mobile? "mobile-") attr "-filter-select-"
                                                    (if (map? revision)
                                                      (get revision attr)
                                                      revision)))]
        [:<>
         (for-frag [{attr  :filter.condition/attribute
                     :keys [values]} selects]
           (let [label-text (filter-label tr attr)]
             [:div {:class width-class}
              [(if filterable-multi-select?
                 ui-ms/filterable-multi-select
                 ui-ms/multi-select)
               (merge {:id          (id attr)
                       :values      values
                       :val->str    (val->str-fn attr)
                       :on-change   #(>evt [set-filter-value-evt attr %])
                       :value       (-> filter-values attr set)
                       :label-text  label-text
                       :light       light?
                       :hide-label? true}
                      (when filterable-multi-select?
                        {:placeholder label-text})
                      (when (some #{attr} [:workspace/assignee :review/assignee])
                        {:compare-items (fn [a b] (cond
                                                    (= a (tr [:ws-es-find/unassigned])) -1
                                                    (= b (tr [:ws-es-find/unassigned])) 1
                                                    :else (compare a b)))}))]]))
         (when (seq date-ranges)
           ;; Starts a row of its own in the wrapping filter row
           [:div.w-full])
         (for-frag [{attr :filter.condition/attribute} date-ranges]
           [:div {:class (if mobile? "w-full mt-4" "hidden md:block w-full lg:w-1/2 px-2 mt-4")}
            [date-range-filter {:tr         tr
                                :id         (id attr)
                                :label-text (filter-label tr attr)
                                :value      (attr filter-values)
                                :light?     light?
                                :on-change  #(>evt [set-date-range-bound-evt attr %1 %2])}]])]))))


(defn quick-filter-button
  [{:keys [tr i filter selected? editing? loading? user-filters select-filter-evt result-count save-quick-filter-evt]}]
  [:div {:class "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 px-2 mt-3"}
   (cond
     loading?
     (cc/select-skeleton {:hide-label true})

     editing?
     [ui-select/select {:id           (str "quick-filter-select-" i)
                        :class-name   "full-width-select quick-filter-select"
                        :allow-empty? true
                        :select-text  (tr [:dashboard-search/select-filter])
                        :values       user-filters
                        :on-change    #(>evt [save-quick-filter-evt i (:db/id %) (:db/id filter)])
                        :value        filter
                        :val->str     :filter/name}]

     filter
     [ui-fb/with-total-number {:on-click  #(>evt [select-filter-evt filter])
                               :total     result-count
                               :text      (:filter/name filter)
                               :selected? selected?}]

     :else
     [:button.bx--btn.bx--btn--tertiary.bx--btn--sm.w-full.justify-center.rounded-full.p-0.h-10
      {:disabled true}
      (tr [:empty])])])


(defn quick-filter-section
  [{:keys [tr title loading? user-filters quick-filters selected-filter select-filter-evt save-quick-filter-evt]}]
  (r/with-let [*editing? (r/atom false)]
    [:div.hidden.md:block
     [:div.flex.items-baseline.mt-6
      [:h4.mr-3 (tr [title])]
      (when-not loading?
        (cc/button {:kind       :ghost
                    :size       :small
                    :on-click   #(swap! *editing? not)
                    :aria-label (tr [(if @*editing?
                                       :dashboard-search/quick-filter-done
                                       :dashboard-search/quick-filter-edit)])}
                   (if @*editing?
                     (tr [:done])
                     (tr [:edit]))))]
     [:div.flex.flex-wrap.-mx-2
      (for-frag [i (range 5)
                 :let [[filter result-count] (->> quick-filters
                                                  (filter #(-> % first :ordered/order (= i)))
                                                  first)]]
        [quick-filter-button (util/mmap {:selected? (= selected-filter filter)
                                         :editing?  @*editing?}
                                        tr
                                        i
                                        filter
                                        loading?
                                        user-filters
                                        select-filter-evt
                                        result-count
                                        save-quick-filter-evt)])]]))
